import { findRequest } from '../../state/state';

const findRequestCohorts = ({ requests }, { category, code }) => {
  const item = findRequest({ requests }, { category, code });
  return { item, cohorts: item.steps.cohorts };
};

export default findRequestCohorts;
